import { createFileRoute } from '@tanstack/react-router';
import { QuizPage } from '../../features/start/quiz-page.tsx';

// The Start here quiz and its result (T33b, spec J6.3–J6.4).
export const Route = createFileRoute('/_authed/start/quiz')({
  component: QuizPage,
});
